<template>
  <s-layout
    left-margin="var(--s-sidebar-collapsed-total)"
    top-margin="var(--topbar-height)"
    padding="0"
  >
    <template #sidebar>
      <Topbar />
      <Sidebar style="z-index: 200;"/>
    </template>

    <div class="page-wrapper">
      <NuxtPage />
    </div>

    <!-- Troca obrigatória de senha: vale em qualquer página autenticada, e o modal não fecha
         enquanto o usuário não definir a nova senha (a flag só cai quando a API confirma).
         Fica dentro do s-layout porque o layout precisa de raiz única: com duas, a transição
         `out-in` entre layouts não termina e a tela fica vazia ao sair. -->
    <Teleport to="body">
      <AuthPasswordChange v-if="trocaObrigatoria" :id="null" v-model="trocaObrigatoria" force />
    </Teleport>
  </s-layout>
</template>

<script setup lang="ts">
import { AuthPasswordChange } from '#components';
import { useAuthStore } from '~/stores/auth';

const authStore = useAuthStore();

//? Setter no-op: só a conclusão da troca (que zera `alterar_senha`) fecha o modal.
const trocaObrigatoria = computed({
  get: () => authStore.user?.alterar_senha === true,
  set: () => {},
});
</script>

<style scoped>
.page-wrapper {
  min-height: 100%;
  padding: 1rem;
  box-sizing: border-box;
}
</style>
